<template>
  <v-container class="fill-height">
    <v-row>
      <v-col :cols="fullView ? 8 : 12">
        <component-properties-table :component="component" v-model="currentProperty" :decorateNumerals="true"/>
      </v-col>
      <v-col cols="4" v-if="fullView">
        <comp-property-card :property="currentProperty.length ? currentProperty[0] : {}" :mode="'viewer'"/>
      </v-col>
      <prj-add-component-property-dialog :component="component" :property="currentProperty" v-model="showAddComponentPropDialog" @propertyAdded="onComponentPropertyAdded" @propertyUpdate="onComponentPropertyAdded"></prj-add-component-property-dialog>
      <sys-confirm-dialog :value="dlgShowConfirm" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteCompProp"/>
    </v-row>
  </v-container>
</template>

<script>
import ComponentPropertiesTable from '@/components/modules/projects/ui/tblCompPropertiesTable'
import CompPropertyCard from '@/components/modules/projects/cards/configuration/compPropertyCard'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import PrjAddComponentPropertyDialog from '@/components/modules/projects/dialogs/prjAddComponentPropertyDialog'

import axios from 'axios'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'

export default {
  name: 'compPropertiesCard',
  components: { SysConfirmDialog, PrjAddComponentPropertyDialog, CompPropertyCard, ComponentPropertiesTable },
  props: ['component', 'activeTab', 'fullView'],
  data () {
    return {
      currentProperty: [],
      showAddComponentPropDialog: false,
      showAddComponentDialog: false,
      dlgShowConfirm: false,
      // addProperty: { text: 'Добавить свойство', actionType: 'Свойства компонента', action: 'addComponentProrerty', method: this.addComponentProp, icon: 'mdi-plus', params: '' },
      editProperty: { text: 'Изменить свойство', actionType: 'Свойства компонента', action: 'updComponentProperty', method: this.updComponentProp, icon: 'mdi-pencil', params: '' }
      // delProperty: { text: 'Удалить свойство', actionType: 'Свойства компонента', action: 'delComponentProperty', method: this.showDelDialog, icon: 'mdi-close', params: '' }
    }
  },
  watch: {
    activeTab (val) {
      console.log('compPropertiesCard - tab changed to ', val)
      this.setActions()
    },
    component (val) {
      console.log('compPropertiesCard - component changed to ', val)
      this.setActions()
    },
    currentProperty (val) {
      console.log('compPropertiesCard - currentProperty changed to ', val)
      this.setActions()
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, {
        actionType: 'Свойства компонента',
        actions: []
      })
      if (this.activeTab === 'tabComponents') {
        // if (this.component && this.component.COMP_ID) { this.$store.dispatch(UI_ADD_ACTION, this.addProperty) }
        if (this.currentProperty.length > 0) {
          this.$store.dispatch(UI_ADD_ACTION, this.editProperty)
          // this.$store.dispatch(UI_ADD_ACTION, this.delProperty)
        }
      }
    },
    addComponentProp () {
      this.currentProperty.splice(this.currentProperty, 1)
      this.showAddComponentPropDialog = true
    },
    updComponentProp () {
      this.showAddComponentPropDialog = true
    },
    showDelDialog () {
      console.log('Calling for confirm dialog')
      this.dlgShowConfirm = true
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    doDeleteCompProp () {
      console.log('Closing confirm dialog')
      this.dlgShowConfirm = false
      const self = this
      const processorPath = '/api/org/receptures/rcptDelRcptCompProperty.php'
      const payload = { ...this.currentProperty[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            self.currentProperty.splice(0, 1)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    onComponentPropertyAdded (data) {
      this.currentProperty.splice(0, 1, data)
      this.showAddComponentPropDialog = false
    }
  },
  mounted () {
    // this.setActions()
  },
  created () {
  }
}
</script>

<style scoped>

</style>
